export const socialFr = {
  "nav.back": "Retour",
  "fav.label": "Favoris",
  "fav.empty": "Clique sur l'étoile d'un son ou d'une musique pour l'ajouter à tes favoris.",
  "mu.sync": "Drop sur le moment fort",
  "mu.sync_on": "Activé",
  "mu.sync_off": "Désactivé",
  "mu.shift": "Décalage",
  "mu.sync_hint": "Le drop de la musique tombe sur ton moment fort ({t}s), plus le décalage.",
  "mu.sync_hint_auto": "Le drop tombe sur le moment fort détecté par l'IA. Utilise « Impact ici » pour le choisir toi-même.",
  "promo.missed": "Le code promo n'était plus disponible au moment du paiement : aucun bonus n'a été ajouté.",
  "promo.remove": "Retirer",
  "adm.pr_saved": "Code enregistré",
  "adm.pr_cancel": "Annuler",
  "adm.tab_ads": "Kit pub",
  "adm.ad_sub": "20 pubs prêtes à publier, dont 10 dédiées à un jeu : verticales (TikTok, Reels, Stories) et carrées (Facebook, Instagram), avec un texte suggéré.",
  "pn.title": "Panneau de contrôle CLIP-EX",
  "pn.private": "Privé : visible seulement par toi, jamais sur ton stream.",
  "pn.open": "Mes clips",
  "pn.live_on": "Auto-clip du live actif",
  "pn.live_off": "Aucun auto-clip de live en cours",
  "pn.live_off_how": "Va dans CLIP-EX > Intégrations, choisis ta plateforme et colle le lien de ton live pour activer « Clipper maintenant ».",
  "pn.buffer": "{s} s en mémoire",
  "pn.stats": "Segments analysés : {s} · Clips : {c}",
  "adm.ad_download_long": "Vidéo ~1 min",
  "pn.clip_now": "Clipper maintenant",
  "pn.clip_now_d": "Crée un clip des 30 dernières secondes de ton live. Il apparaît ci-dessous en temps réel.",
  "pn.sound_on": "Activer le son et la vibration",
  "pn.qr_title": "Ouvre ce bouton CLIP sur ton cell",
  "pn.qr_desc": "Scanne ce code QR avec l'appareil photo de ton cell : il ouvre directement ce panneau, sans connexion. Garde-le pour toi.",
  "pn.sound_off": "Couper le son et la vibration",
  "pn.chat_on": "Tes modos et VIP peuvent aussi taper !clip ou !clip 60 (jusqu'à 60 s) dans le chat (1 clip max / 30 s).",
  "pn.requested": "Clip demandé ! Il apparaît dans quelques secondes.",
  "pn.ready": "Clip prêt :",
  "pn.recent": "Clips en temps réel",
  "pn.none": "Aucun clip pour l'instant.",
  "pn.manual": "Clipper maintenant",
  "pn.auto": "IA",
  "pn.st_rendering": "en création",
  "pn.st_queued": "en attente",
  "pn.st_done": "prêt",
  "pn.st_error": "erreur",
  "pn.invalid": "Lien de panneau invalide. Copie-le à nouveau depuis CLIP-EX > Intégrations.",
  "int.ov_invisible": "Overlay invisible (recommandé)",
  "int.ov_alert": "Overlay avec alerte discrète de 3 s « Clip ! »",
  "int.ov_note": "Rien ne s'affiche sur ton stream : aucun nom, aucun panneau. Tes viewers ne voient rien.",
  "int.panel_t": "Panneau privé + « Clipper maintenant »",
  "int.panel_d": "Ouvre-le sur ton téléphone, un 2e écran ou comme dock OBS (Docks > Docks de navigateur personnalisés). Il n'est jamais diffusé.",
  "int.panel_open": "Ouvrir le panneau",
  "int.guide_t": "Comment ça marche",
  "int.guide_1": "Lance ton live sur TikTok, Twitch, Kick ou YouTube.",
  "int.guide_2": "Dans « Connecter une plateforme » ci-dessous, choisis ta plateforme, colle le lien de ton live et clique « Lancer l'auto-clip ». CLIP-EX enregistre ton live, l'IA crée les clips des meilleurs moments.",
  "int.guide_3": "Ouvre le panneau privé : appuie sur « Clipper maintenant » pour garder les 30 dernières secondes. Les clips apparaissent en temps réel dans le panneau et dans « Mes clips ».",
  "int.guide_4": "Optionnel : ajoute l'overlay invisible comme source Navigateur/Lien (1920x1080). Choisis la version avec alerte si tu veux un petit « Clip ! » de 3 s à l'écran.",
  "int.sw_tiktok": "TikTok LIVE Studio : pas de plugin nécessaire. Utilise l'auto-clip avec le lien tiktok.com/@toi/live + le panneau privé sur ton téléphone. Overlay : Ajouter une source > Lien.",
  "int.sw_obs": "OBS Studio : installe le plugin (Outils > Scripts), clique « Tester la connexion », puis assigne la touche « CLIP-EX : Clipper maintenant » dans Paramètres > Raccourcis. Le panneau privé s'ajoute en dock.",
  "int.sw_streamlabs": "Streamlabs : ajoute le panneau privé dans une fenêtre à côté, active le Replay Buffer et lance le Watcher sur ton dossier de replays. Overlay : source Navigateur.",
  "int.test": "Tester la connexion",
  "int.test_ok": "Connexion OK :",
  "sub.title": "Sous-titres animés IA",
  "sub.desc": "L'IA transcrit ta voix mot par mot (langue détectée automatiquement) et anime chaque mot façon karaoké.",
  "sub.transcribe": "Transcrire et voir le texte",
  "sub.edit": "Corrige le texte si besoin (les mots gardent leur timing) :",
  "sub.auto": "Sans transcription manuelle, l'IA la fait automatiquement à l'aperçu et à l'export.",
  "sub.empty": "Aucune parole détectée dans ce passage.",
  "sub.pos_auto": "Auto",
  "sub.pos_high": "Haut",
  "sub.pos_middle": "Milieu",
  "sub.pos_low": "Bas",
  "ed.tab_moments": "Moments IA",
  "ed.tab_format": "Cadrage",
  "ed.tab_subs": "Sous-titres",
  "ed.tab_stickers": "Stickers",
  "ed.tab_audio": "Sons",
  "ed.tab_fx": "Effets",
  "ed.tab_export": "Publier",
  "st.drag_hint": "Mets la vidéo sur pause : glisse le sticker sur l'aperçu pour le placer, tire le rond bleu pour l'agrandir et le rond violet pour le faire pivoter.",
  "st.pos_start": "Position de départ",
  "st.rotation": "Rotation",
  "gift.title": "J'ai un code cadeau",
  "gift.ph": "CODE CADEAU",
  "gift.redeem": "Recevoir mes clips",
  "gift.ok": "🎁 {n} clips ajoutés à ton compte !",
  "cg.title": "Choisis ta carte !",
  "cg.sub": "Une seule chance : gagne {p} clips gratuits.",
  "cg.won": "Bravo ! +{n} clips",
  "cg.won_sub": "Tes clips gratuits sont déjà sur ton compte. Voici ce que cachaient les autres cartes…",
  "cg.done": "Génial !",
  "cg.share": "Partager mon gain",
  "cg.share_text": "🎴 J'ai gagné {n} clips gratuits sur CLIP-EX avec le code {code} ! Essaie toi aussi :",
  "cg.copied": "Message copié ! Colle-le où tu veux.",
  "adm.pr_game": "Jeu de cartes (le client choisit une carte)",
  "adm.pr_prizes": "Gains des cartes (clips)",
  "adm.pr_game_row": "Cartes : {p} clips",
  "adm.pr_kind": "Type de code",
  "adm.pr_kind_bonus": "Bonus à l'achat",
  "adm.pr_kind_gift": "Gratuit (sans achat)",
  "adm.pr_gift_clips": "Clips offerts",
  "adm.pr_gift_row": "Cadeau : {n} clips",
  "adm.gift_btn": "Offrir des clips",
  "adm.credits_col": "Crédits",
  "adm.gift_clips": "Nombre de clips",
  "adm.gift_note": "Message (optionnel)",
  "adm.gift_send": "Offrir",
  "adm.gift_done": "{n} clips offerts à {e}",
  "gc.title": "Carte cadeau",
  "adm.pr_used": "Utilisé / terminé",
  "gc.make": "Créer une carte cadeau à partager (lien unique, 1 utilisation)",
  "gc.to": "Pour (prénom ou pseudo)",
  "gc.create": "Créer la carte",
  "gc.download": "Télécharger l'image",
  "gc.copy": "Copier le message",
  "gc.copied": "Message copié !",
  "gc.share_text": "🎁 Je t'offre {n} clips sur CLIP-EX ! Récupère-les ici : {u}",
  "gc.share_text_direct": "🎁 Je t'ai offert {n} clips sur CLIP-EX ! Ils sont déjà sur ton compte.",
  "gc.hint_code": "Envoie le lien ou l'image par texto, Discord ou courriel. La première personne qui l'utilise reçoit les clips.",
  "gc.hint_direct": "Les clips sont déjà sur le compte du client : partage-lui cette carte pour lui faire plaisir.",
  "gc.headline": "Tu as reçu {n} clips CLIP-EX !",
  "gc.for": "Pour",
  "gc.signup": "Créer mon compte et recevoir mes clips",
  "gc.used": "Cette carte cadeau a déjà été utilisée.",
  "gc.direct": "Ces clips ont déjà été ajoutés au compte.",
  "gc.invalid": "Carte cadeau introuvable.",
  "pro.title": "Montage Pro auto",
  "pro.desc": "Un clic et CLIP-EX monte comme un pro : coupe des temps morts, zoom sur les cris, accroche, barre de progression et écran « Abonne-toi ».",
  "pro.on": "Montage Pro activé",
  "pro.cuts": "Couper les silences et temps morts",
  "pro.zooms": "Zoom sur les cris et pics de son",
  "pro.whoosh": "Whoosh à chaque coupe",
  "pro.hook": "Accroche IA au début",
  "pro.progress": "Barre de progression",
  "pro.endcard": "Écran final « Abonne-toi » (2 s)",
  "pro.btn": "✨ Montage Pro",
  "pro.preview_hint": "Le résultat se voit avec « Aperçu réel » et dans le clip exporté.",
  "var.title": "3 variantes + score viral",
  "var.desc": "Un moment, trois montages : hype, drôle et cinématique. Chaque version reçoit une note virale /100 et 3 conseils.",
  "var.btn": "Créer 3 variantes · 1 crédit",
  "var.busy": "L'IA prépare tes 3 montages…",
  "var.started": "3 variantes en cours de création",
  "var.hype": "Hype",
  "var.funny": "Drôle",
  "var.cinematic": "Cinématique",
  "var.best": "Meilleure note",
  "var.rendering": "Montage en cours…",
  "var.error": "Échec du rendu",
  "var.tips": "Conseils pour exploser",
  "var.download": "Télécharger",
  "var.see_all": "Voir dans mes clips",
  "var.need_range": "Choisis d'abord un moment ou une sélection.",
  "tpl.title": "Mes modèles de clips",
  "tpl.desc": "Sauvegarde ton style et applique-le en 1 clic. Le modèle ⭐ par défaut s'applique tout seul à chaque nouveau clip IA, auto et live.",
  "tpl.name": "Nom du modèle (ex. Mon style TikTok)",
  "tpl.save": "Sauvegarder mon style",
  "tpl.saved": "Modèle sauvegardé",
  "tpl.applied": "Modèle « {n} » appliqué",
  "tpl.default": "Modèle par défaut",
  "tpl.set_default": "Définir par défaut",
  "tpl.unset_default": "Retirer le défaut",
  "tpl.deleted": "Modèle supprimé",
  "tpl.empty": "Aucun modèle pour l'instant : règle ton clip puis sauvegarde ton style.",
  "tpl.auto_applied": "Ton modèle par défaut « {n} » est appliqué",
  "face.title": "Recadrage visage auto",
  "face.desc": "Détecte ta facecam : visage en haut, gameplay en bas qui suit l'action.",
  "face.found": "Facecam détectée",
  "face.none": "Aucune facecam détectée",
  "face.scanning": "Recherche de ton visage…",
  "face.detect": "Détecter mon visage",
  "face.applied": "Facecam détectée : écran partagé activé",
  "face.only916": "Disponible en format vertical 9:16",
  "hq.label": "Qualité Pro",
  "hq.hint": "Netteté, débruitage, couleurs vives, son normalisé (-14 LUFS) et encodage haute qualité.",
  "cmp.open": "Comparer en plein écran",
  "cmp.title": "Compare tes 3 variantes",
  "cmp.desc": "Elles jouent en même temps. Touche une vidéo pour l'écouter, puis garde la gagnante.",
  "cmp.play": "Tout lire",
  "cmp.pause": "Pause",
  "cmp.restart": "Recommencer",
  "cmp.listening": "Son activé",
  "cmp.tap_listen": "Touche pour écouter",
  "cmp.keep": "Garder celle-ci",
  "cmp.kept": "Variante gardée · {n} supprimée(s)",
  "pub.btn": "Publier",
  "pub.title": "Publier mon clip",
  "pub.desc": "Titre, description et hashtags écrits par l'IA, modifiables avant l'envoi.",
  "pub.soon": "bientôt",
  "pub.not_configured": "La publication YouTube arrive très bientôt : l'app Google de CLIP-EX est en cours de configuration.",
  "pub.connect": "Connecter ma chaîne YouTube",
  "pub.disconnect": "Déconnecter",
  "pub.connected": "Chaîne YouTube connectée",
  "pub.r_denied": "Connexion YouTube annulée",
  "pub.r_error": "La connexion YouTube a échoué, réessaie",
  "pub.r_nochannel": "Aucune chaîne YouTube sur ce compte Google",
  "pub.ai_filled": "Rempli par l'IA, modifie ce que tu veux",
  "pub.writing": "L'IA écrit ton titre et tes hashtags…",
  "pub.f_title": "Titre",
  "pub.f_desc": "Description",
  "pub.f_tags": "Hashtags",
  "pub.p_public": "Public",
  "pub.p_unlisted": "Non répertorié",
  "pub.p_private": "Privé",
  "pub.send": "Publier sur YouTube Shorts",
  "pub.started": "Envoi vers YouTube en cours…",
  "pub.on_youtube": "En ligne sur YouTube Shorts",
  "pub.uploading": "Envoi vers YouTube…",
  "pub.failed": "Échec de la publication",
  "pub.refresh": "Rafraîchir",
  "pub.refreshed": "Vues mises à jour",
  "pub.refresh_failed": "Impossible de rafraîchir les vues pour le moment",
  "pub.build": "YouTube : en construction",
  "pub.build_hint": "La publication directe sur YouTube Shorts arrive bientôt.",
  "pl.result": "Résultat",
  "pl.source": "Source",
  "pl.final": "Aperçu final (6 s)",
  "adm.tab_stripe": "Stripe",
  "cr.ledger": "Historique des crédits",
  "cr.no_ledger": "Aucun mouvement de crédits pour l'instant.",
  "cr.refunded": "{n} clips remboursés",
  "cr.k_purchase": "Achat de crédits",
  "cr.k_holiday_pack": "Pack de fête débloqué",
  "cr.k_holiday_bonus": "Bonus de fête à l'achat",
  "cr.k_promo_bonus": "Bonus code promo",
  "cr.k_refund": "Remboursement (crédits retirés)",
  "cr.k_consume": "Clip généré",
  "cr.k_clip_refund": "Clip échoué : crédit rendu",
  "cr.k_gift_code": "Code cadeau utilisé",
  "cr.k_gift_admin": "Cadeau de CLIP-EX",
  "cr.k_challenge": "Défi gagné",
  "cr.k_referral": "Bonus de parrainage",
  "gc.email": "Courriel du client (optionnel, envoie la carte)",
  "gc.emailed": "Carte cadeau envoyée par courriel",
  "sc.btn": "Raccourcis",
  "sc.title": "Raccourcis clavier",
  "sc.play": "Lecture / pause",
  "sc.start": "Début de la sélection ici",
  "sc.end": "Fin de la sélection ici",
  "sc.save": "Sauvegarder le moment sélectionné",
  "sc.export": "Exporter le clip",
  "sc.seek1": "Reculer / avancer d'1 s",
  "sc.seek5": "Reculer / avancer de 5 s",
  "sc.mute": "Couper / remettre le son",
  "sc.final": "Aperçu final (6 s)",
  "sc.help": "Afficher cette aide",
  "sc.space": "Espace",
  "sc.shift": "Maj + ← / →",
  "sc.start_set": "Début placé",
  "sc.end_set": "Fin placée",
  "ns.create": "Créer",
  "ns.create_d": "Importer une vidéo, faire des clips",
  "ns.clips": "Mes clips",
  "ns.clips_d": "Clips, partages et statistiques",
  "ns.live": "Live",
  "ns.live_d": "OBS, Streamlabs, TikTok, clips en direct",
  "ns.account": "Mon compte",
  "ns.account_d": "Crédits, équipe et aide",
  "ns.more": "Plus",
  "ns.community": "Communauté et extras",
  "sty.legend": "vues moy. · likes · score viral moy.",
  "pub.vs_score": "Score viral prédit",
  "sty.title": "Quel style marche le mieux",
  "sty.avg_views": "Vues moyennes par clip publié",
  "sty.likes": "Likes",
  "sty.avg_score": "Score viral moyen",
  "sty.counts": "{c} clip(s) · {p} publié(s)",
  "sty.empty": "Publie tes variantes sur YouTube Shorts pour voir quel style fait le plus de vues. Mise à jour toutes les 6 h.",
  "adm.ad_game_all": "Toutes",
  "adm.ad_long_title": "Pubs longues 60 s",
  "adm.ad_long_sub": "Présentations complètes avec voix off IA : produit, fonctions, offres et codes promo.",
  "adm.ad_games_title": "Classement des jeux",
  "adm.ad_games_sub": "Visites et inscrits venant des pubs du jeu, achats venant de ses pubs ou de son code promo.",
  "adm.ad_col_game": "Jeu",
  "adm.ad_col_purchases": "Achats",
  "adm.ad_col_codes": "Codes utilisés",
  "adm.ad_game_general": "Générales",
  "adm.ad_download": "Télécharger",
  "adm.ad_copy": "Copier le texte",
  "adm.ad_copied": "Texte copié avec ton lien suivi !",
  "adm.ad_link_copied": "Lien suivi copié !",
  "adm.ad_report_btn": "Recevoir le rapport hebdo maintenant",
  "adm.ad_report_sent": "Rapport envoyé à ton adresse d'alerte.",
  "adm.ad_report_fail": "Le rapport n'a pas pu être envoyé.",
  "adm.ad_video": "Vidéo",
  "adm.ad_image": "Image",
  "adm.ad_download_video": "Vidéo 6 s",
  "adm.ad_stats": "Performance des pubs",
  "adm.ad_stats_sub": "Visites, inscriptions (jusqu'à 30 jours après le clic) et achats, par pub et par réseau.",
  "adm.ad_stats_empty": "Pas encore de visites. Publie tes pubs avec leurs liens suivis pour voir les résultats ici.",
  "adm.ad_col_ad": "Pub", "adm.ad_col_src": "Réseau", "adm.ad_col_visits": "Visites", "adm.ad_col_signups": "Inscrits",
  "adm.ad_col_rate": "Taux", "adm.ad_col_buyers": "Acheteurs", "adm.ad_col_rev": "Revenus", "adm.ad_total": "Total",
  "promo.ph": "Code promo",
  "promo.apply": "Appliquer",
  "promo.ok": "Code {code} appliqué !",
  "promo.applied": "Clips bonus offerts ajoutés après le paiement",
  "promo.plus": "+{n} clips bonus offerts",
  "adm.tab_promos": "Codes promo",
  "adm.tab_holidays": "Fêtes",
  "hol.adm_intro": "Active un skin de fête sur tout le site (déco discrète + couleur), rends disponibles les packs de stickers et sons en crédits, et lance des promos. Chaque option s'active ou se désactive d'un clic.",
  "hol.adm_skin": "Skin de fête sur le site",
  "hol.adm_pack": "Pack stickers & sons à vendre",
  "hol.adm_price": "Prix (crédits)",
  "hol.adm_bonus": "Bonus de crédits à l'achat",
  "hol.adm_promo": "Afficher un code promo de fête",
  "hol.adm_free": "Pack offert avec un achat",
  "hol.adm_owners": "{n} possèdent le pack",
  "hol.adm_saved": "Fêtes mises à jour",
  "hol.adm_promo_missing": "Ce code n'existe pas encore : crée-le dans l'onglet Codes promo.",
  "hol.perk_bonus": "+{n} % de crédits sur chaque forfait",
  "hol.perk_pack": "pack de fête offert avec un achat",
  "hol.perk_code": "code {c}",
  "hol.locked": "Ce sticker/son fait partie d'un pack de fête à débloquer.",
  "hol.unlock": "Débloquer",
  "hol.packs_title": "Packs de fête",
  "hol.packs_sub": "Stickers et sons exclusifs, débloqués une fois avec tes crédits et gardés pour toujours.",
  "hol.pack_count": "{s} stickers · {n} sons",
  "hol.buy": "Débloquer · {n} crédits",
  "hol.owned": "Débloqué",
  "hol.bought": "Pack débloqué ! Il est maintenant dans l'éditeur.",
  "hol.sch_label": "Dates automatiques (chaque année)",
  "hol.sch_auto": "calculé",
  "hol.sch_bad": "Format attendu : MM-JJ (ex. 12-01)",
  "hol.sch_live": "En cours",
  "hol.sch_window": "Prochaine période : du {a} au {b}",
  "hol.sch_current": "En cours : du {a} au {b}",
  "hol.sch_reset": "Dates suggérées",
  "hol.sch_intro": "Avec les dates automatiques, la fête (skin + options cochées) s'allume et s'éteint toute seule, heure de Montréal. Sans dates, les options marchent à la main. Le skin choisi à la main a priorité.",
  "hol.sch_now": "Skin visible en ce moment : {n}.",
  "hol.sch_none": "Aucun skin visible en ce moment.",
  "hol.ov_label": "Déco de fête dans mon overlay",
  "hol.ov_now": "Fête en cours : {n}",
  "hol.ov_none": "Aucune fête en cours, rien ne s'affiche pour l'instant.",
  "hol.ov_preview": "Aperçu",
  "hol.ov_on": "Déco de fête activée dans ton overlay",
  "hol.ov_off": "Déco de fête retirée de ton overlay",
  "hol.snd_on": "Activer le son de fête",
  "hol.snd_off": "Couper le son de fête",
  "adm.pr_new": "Nouveau code",
  "adm.pr_code": "Code",
  "adm.pr_bonus_small": "Bonus Petit (10)",
  "adm.pr_bonus_medium": "Bonus Moyen (30)",
  "adm.pr_bonus_large": "Bonus Grand (100)",
  "adm.pr_max": "Utilisations max",
  "adm.pr_ends": "Date de fin (optionnelle)",
  "adm.pr_active": "Actif",
  "adm.pr_inactive": "Inactif",
  "adm.pr_save": "Enregistrer",
  "adm.pr_uses": "{u}/{m} utilisations",
  "adm.ps_users": "Personnes",
  "adm.ps_active": "Ont clippé",
  "adm.ps_clips": "Clips créés",
  "adm.ps_buyers": "Ont acheté",
  "adm.ps_revenue": "Ventes après",
  "adm.ps_n_clips": "{n} clips",
  "adm.ps_empty": "Personne n'a encore utilisé ce code.",
  "adm.pr_no_end": "Sans date de fin",
  "adm.pr_until": "Jusqu'au {d}",
  "adm.pr_delete_confirm": "Supprimer ce code promo ?",
  "adm.pr_empty": "Aucun code promo.",
  "st.tab_music": "Musique",
  "mu.vol": "Musique",
  "mu.orig_vol": "Son du clip",
  "mu.note": "Musiques originales créées par IA, libres de droits : aucun risque de blocage sur TikTok, Reels ou Shorts. La musique tourne en boucle sur toute la durée du clip.",
  "mu.cat_all": "Toutes", "mu.cat_meme": "Mèmes", "mu.cat_phonk": "Phonk", "mu.cat_drill": "Drill", "mu.cat_hype": "Hype", "mu.cat_epic": "Épique",
  "mu.cat_suspense": "Suspense", "mu.cat_comedy": "Comédie", "mu.cat_lofi": "Lo-fi", "mu.cat_emotional": "Émotion", "mu.cat_retro": "Rétro",
  "cr.title": "Crédits",
  "cr.sub": "1 crédit = 1 clip exporté, en plus de tes 3 clips gratuits chaque semaine. Les crédits n'expirent jamais.",
  "cr.free": "Gratuits cette semaine",
  "cr.bonus": "Clips bonus",
  "cr.paid": "Crédits achetés",
  "cr.clips": "{n} clips",
  "cr.per_clip": "{p} / clip",
  "cr.buy": "Acheter",
  "cr.soon": "Disponible bientôt",
  "cr.popular": "Populaire",
  "cr.best": "Meilleur prix",
  "cr.secure": "Paiement sécurisé par Stripe · taxes calculées au paiement · en dollars canadiens",
  "cr.history": "Historique des achats",
  "cr.no_history": "Aucun achat pour le moment.",
  "cr.demo": "Le compte démo ne peut pas acheter de crédits. Crée ton compte gratuit pour continuer.",
  "cr.out": "Tes clips gratuits de la semaine sont utilisés.",
  "cr.get": "Obtenir des crédits",
  "pay.checking": "Vérification du paiement…",
  "pay.success": "Paiement réussi !",
  "pay.success_sub": "Tes crédits ont été ajoutés à ton compte.",
  "pay.pending": "Paiement en cours de confirmation. Tu peux revenir dans quelques minutes.",
  "pay.failed": "Le paiement n'a pas abouti.",
  "pay.cancel": "Paiement annulé",
  "pay.cancel_sub": "Aucun montant n'a été prélevé.",
  "pay.back": "Retour aux crédits",
  "pay.to_clips": "Créer un clip",
  "ex.bars": "Bandes noires",
  "ex.split": "Écran partagé",
  "fr.zone_cam": "Facecam",
  "fr.zone_game": "Gameplay",
  "fr.split_ratio": "Taille facecam",
  "fr.hint_split": "Glisse et zoome chaque zone séparément",
  "fr.cam_pick": "Dessine le rectangle de ta facecam",
  "fr.cam_hint": "Trace un rectangle sur ta caméra, ou glisse-le pour le déplacer.",
  "fr.memory": "Ton cadrage est mémorisé pour ce format et réutilisé sur tes prochains clips.",
  "fr.title": "Cadrage de la vidéo",
  "fr.reset": "Réinitialiser",
  "fr.hint": "Glisse pour déplacer · molette ou pincement pour zoomer",
  "fr.grid": "Grille des tiers",
  "fr.safe": "Zones de sécurité",
  "fr.safe_ui": "Interface de l'app",
  "fr.safe_caption": "Texte et légende",
  "fr.preset_center": "Centré",
  "fr.preset_facecam": "Facecam en haut",
  "fr.preset_gameplay": "Gameplay plein écran",
  "adm.demo_title": "Compte démo",
  "adm.demo_desc": "Efface les vidéos et clips du compte démo et remet un exemple propre : 1 vidéo analysée par l'IA et 3 clips prêts (9:16, 16:9, 1:1).",
  "adm.demo_btn": "Réinitialiser le démo",
  "adm.demo_confirm": "Effacer tout le contenu du compte démo et remettre l'exemple ?",
  "adm.demo_done": "Réinitialisation lancée : les 3 clips seront prêts dans une minute environ.",
  "nav.following": "Abonnements",
  "nav.challenges": "Défis",
  "ch.nav": "Défis",
  "ch.label": "Défi de la semaine",
  "ch.title1": "Le défi ",
  "ch.title2": "de la commu",
  "ch.sub": "Inscris ton meilleur clip partagé. La communauté vote avec ses réactions : le clip le plus réactif à la fin du défi gagne des clips bonus.",
  "ch.none": "Aucun défi en cours pour l'instant. Reviens bientôt !",
  "ch.active": "En cours",
  "ch.upcoming": "À venir",
  "ch.ended": "Terminé",
  "ch.reward": "{n} clips bonus au gagnant",
  "ch.entries": "{n} clips inscrits",
  "ch.entries_one": "{n} clip inscrit",
  "ch.ends_in": "Se termine dans",
  "ch.starts": "Commence le {date}",
  "ch.ended_on": "Terminé le {date}",
  "ch.days": "j", "ch.hours": "h", "ch.minutes": "min",
  "ch.enter": "Inscrire mon clip",
  "ch.change": "Changer mon clip",
  "ch.withdraw": "Retirer mon clip",
  "ch.withdrawn": "Clip retiré du défi",
  "ch.entered": "Clip inscrit au défi !",
  "ch.login": "Connecte-toi pour participer",
  "ch.my_entry": "Ton clip est inscrit",
  "ch.ranking": "Classement en direct",
  "ch.vote_hint": "Vote pour tes clips préférés avec les réactions feu, crâne et GG. Une réaction de chaque type par appareil.",
  "ch.no_entries": "Aucun clip inscrit pour l'instant. Sois le premier !",
  "ch.score": "{n} réactions",
  "ch.score_one": "{n} réaction",
  "ch.winner": "Gagnant",
  "ch.no_winner": "Aucun gagnant (aucune réaction)",
  "ch.past": "Défis précédents",
  "ch.pick_title": "Choisis le clip à inscrire",
  "ch.pick_desc": "Seuls tes clips partagés publiquement peuvent participer. Un clip par espace et par défi.",
  "ch.pick_empty": "Tu n'as aucun clip partagé. Active « Partager » sur un clip exporté, puis reviens ici.",
  "ch.pick_confirm": "Inscrire ce clip",
  "ch.game": "Jeu",
  "ch.rules": "Le gagnant reçoit ses clips bonus automatiquement à la fin du défi. Les clips bonus n'expirent jamais.",

  "adm.tab_challenges": "Défis",
  "adm.ch_new": "Nouveau défi",
  "adm.ch_edit": "Modifier le défi",
  "adm.ch_title": "Titre (ex. Meilleur clutch)",
  "adm.ch_desc": "Description et règles",
  "adm.ch_game": "Jeu (optionnel)",
  "adm.ch_start": "Début",
  "adm.ch_end": "Fin",
  "adm.ch_save": "Enregistrer",
  "adm.ch_cancel": "Annuler",
  "adm.ch_created": "Défi enregistré",
  "adm.ch_close": "Clôturer maintenant",
  "adm.ch_close_confirm": "Clôturer ce défi maintenant et attribuer les clips bonus au clip en tête ?",
  "adm.ch_closed": "Défi clôturé",
  "adm.ch_delete": "Supprimer",
  "adm.ch_delete_confirm": "Supprimer ce défi et ses inscriptions ?",
  "adm.ch_deleted": "Défi supprimé",
  "adm.ch_empty": "Aucun défi. Crée le premier !",
  "adm.ch_leader": "En tête",
  "adm.ch_intro": "Crée des défis hebdomadaires. Les créateurs inscrivent un clip partagé, la communauté vote avec ses réactions et le gagnant reçoit automatiquement 3 clips bonus à la fin.",

  "adm.tab_email": "Courriels",
  "adm.tab_cleanup": "Nettoyage",
  "adm.tab_real": "Vrais chiffres",
  "adm.em_title": "Domaine d'envoi",
  "adm.em_intro": "Les courriels partent automatiquement de {sender} dès que le domaine est vérifié dans Resend. En attendant, l'expéditeur actuel est utilisé. Le statut est revérifié toutes les 15 minutes.",
  "adm.em_active": "Actif : les courriels partent de {sender}",
  "adm.em_pending": "En attente de vérification DNS",
  "adm.em_failed": "Vérification échouée : vérifie les enregistrements",
  "adm.em_missing": "Domaine absent du compte Resend",
  "adm.em_unreachable": "Resend injoignable pour l'instant",
  "adm.em_records": "Enregistrements DNS à ajouter chez ton registraire",
  "adm.em_type": "Type", "adm.em_name": "Nom", "adm.em_value": "Valeur", "adm.em_prio": "Priorité", "adm.em_status": "Statut",
  "adm.em_verify": "Vérifier maintenant",
  "adm.em_verified": "Vérification relancée",
  "adm.em_copied": "Copié",
  "adm.em_tip": "Astuce : chez la plupart des registraires, le champ « Nom » s'écrit sans « clip-ex.ca » à la fin. La propagation DNS peut prendre de quelques minutes à 48 h.",

  "fw.follow": "Suivre",
  "fw.following": "Abonné",
  "fw.unfollow": "Ne plus suivre",
  "fw.followed": "Tu suis maintenant {name}",
  "fw.unfollowed": "Tu ne suis plus {name}",
  "fw.self": "C'est ton profil",
  "fw.label": "Ton fil",
  "fw.title1": "Mes ",
  "fw.title2": "abonnements",
  "fw.sub": "Les derniers clips partagés par les créateurs que tu suis.",
  "fw.creators": "Créateurs suivis",
  "fw.empty": "Tu ne suis encore aucun créateur. Découvre-en dans la vitrine et clique sur « Suivre » sur leur profil.",
  "fw.no_clips": "Les créateurs que tu suis n'ont pas encore partagé de clip.",
  "fw.discover": "Découvrir la vitrine",
};

export const socialEn = {
  "nav.back": "Back",
  "fav.label": "Favorites",
  "fav.empty": "Click the star on a sound or track to add it to your favorites.",
  "mu.sync": "Drop on the highlight",
  "mu.sync_on": "On",
  "mu.sync_off": "Off",
  "mu.shift": "Offset",
  "mu.sync_hint": "The music drop lands on your highlight ({t}s), plus the offset.",
  "mu.sync_hint_auto": "The drop lands on the highlight detected by the AI. Use “Impact here” to pick it yourself.",
  "promo.missed": "The promo code was no longer available at payment time: no bonus was added.",
  "promo.remove": "Remove",
  "adm.pr_saved": "Code saved",
  "adm.pr_cancel": "Cancel",
  "adm.tab_ads": "Ad kit",
  "adm.ad_sub": "20 ready-to-post ads, 10 of them game-specific: vertical (TikTok, Reels, Stories) and square (Facebook, Instagram), with a suggested caption.",
  "pn.title": "CLIP-EX control panel",
  "pn.private": "Private: only you see it, never on your stream.",
  "pn.open": "My clips",
  "pn.live_on": "Live auto-clip running",
  "pn.live_off": "No live auto-clip running",
  "pn.live_off_how": "Go to CLIP-EX > Integrations, pick your platform and paste your live link to enable \"Clip now\".",
  "pn.buffer": "{s} s buffered",
  "pn.stats": "Segments analyzed: {s} · Clips: {c}",
  "adm.ad_download_long": "~1 min video",
  "pn.clip_now": "Clip now",
  "pn.clip_now_d": "Creates a clip of the last 30 seconds of your live. It shows up below in real time.",
  "pn.sound_on": "Turn on sound and vibration",
  "pn.qr_title": "Open this CLIP button on your phone",
  "pn.qr_desc": "Scan this QR code with your phone camera: it opens this panel directly, no login. Keep it to yourself.",
  "pn.sound_off": "Mute sound and vibration",
  "pn.chat_on": "Your mods and VIPs can also type !clip or !clip 60 (up to 60 s) in chat (max 1 clip / 30 s).",
  "pn.requested": "Clip requested! It will show up in a few seconds.",
  "pn.ready": "Clip ready:",
  "pn.recent": "Real-time clips",
  "pn.none": "No clips yet.",
  "pn.manual": "Clip now",
  "pn.auto": "AI",
  "pn.st_rendering": "rendering",
  "pn.st_queued": "queued",
  "pn.st_done": "ready",
  "pn.st_error": "error",
  "pn.invalid": "Invalid panel link. Copy it again from CLIP-EX > Integrations.",
  "int.ov_invisible": "Invisible overlay (recommended)",
  "int.ov_alert": "Overlay with a discreet 3 s \"Clip!\" alert",
  "int.ov_note": "Nothing shows on your stream: no name, no panel. Your viewers see nothing.",
  "int.panel_t": "Private panel + \"Clip now\"",
  "int.panel_d": "Open it on your phone, a 2nd screen or as an OBS dock (Docks > Custom Browser Docks). It is never broadcast.",
  "int.panel_open": "Open the panel",
  "int.guide_t": "How it works",
  "int.guide_1": "Start your live on TikTok, Twitch, Kick or YouTube.",
  "int.guide_2": "In \"Connect a platform\" below, pick your platform, paste your live link and click \"Start live auto-clip\". CLIP-EX records your live and the AI clips the best moments.",
  "int.guide_3": "Open the private panel: press \"Clip now\" to keep the last 30 seconds. Clips show up in real time in the panel and in \"My clips\".",
  "int.guide_4": "Optional: add the invisible overlay as a Browser/Link source (1920x1080). Pick the alert version for a small 3 s \"Clip!\" on screen.",
  "int.sw_tiktok": "TikTok LIVE Studio: no plugin needed. Use the auto-clip with your tiktok.com/@you/live link + the private panel on your phone. Overlay: Add source > Link.",
  "int.sw_obs": "OBS Studio: install the plugin (Tools > Scripts), click \"Test connection\", then bind the \"CLIP-EX : Clip now\" hotkey in Settings > Hotkeys. Add the private panel as a dock.",
  "int.sw_streamlabs": "Streamlabs: keep the private panel in a window next to it, enable the Replay Buffer and run the Watcher on your replay folder. Overlay: Browser source.",
  "int.test": "Test connection",
  "int.test_ok": "Connected:",
  "sub.title": "AI animated subtitles",
  "sub.desc": "AI transcribes your voice word by word (language auto-detected) and animates each word karaoke-style.",
  "sub.transcribe": "Transcribe and show text",
  "sub.edit": "Fix the text if needed (words keep their timing):",
  "sub.auto": "Without manual transcription, AI does it automatically on preview and export.",
  "sub.empty": "No speech detected in this part.",
  "sub.pos_auto": "Auto",
  "sub.pos_high": "Top",
  "sub.pos_middle": "Middle",
  "sub.pos_low": "Bottom",
  "ed.tab_moments": "AI moments",
  "ed.tab_format": "Framing",
  "ed.tab_subs": "Subtitles",
  "ed.tab_stickers": "Stickers",
  "ed.tab_audio": "Sounds",
  "ed.tab_fx": "Effects",
  "ed.tab_export": "Publish",
  "st.drag_hint": "Pause the video: drag the sticker on the preview to place it, pull the blue dot to resize and the purple dot to rotate.",
  "st.pos_start": "Starting position",
  "st.rotation": "Rotation",
  "gift.title": "I have a gift code",
  "gift.ph": "GIFT CODE",
  "gift.redeem": "Get my clips",
  "gift.ok": "🎁 {n} clips added to your account!",
  "cg.title": "Pick your card!",
  "cg.sub": "One shot: win {p} free clips.",
  "cg.won": "Nice! +{n} clips",
  "cg.won_sub": "Your free clips are already on your account. Here's what the other cards were hiding…",
  "cg.done": "Awesome!",
  "cg.share": "Share my win",
  "cg.share_text": "🎴 I just won {n} free clips on CLIP-EX with code {code}! Try it too:",
  "cg.copied": "Message copied! Paste it anywhere.",
  "adm.pr_game": "Card game (customer picks a card)",
  "adm.pr_prizes": "Card prizes (clips)",
  "adm.pr_game_row": "Cards: {p} clips",
  "adm.pr_kind": "Code type",
  "adm.pr_kind_bonus": "Purchase bonus",
  "adm.pr_kind_gift": "Free (no purchase)",
  "adm.pr_gift_clips": "Gifted clips",
  "adm.pr_gift_row": "Gift: {n} clips",
  "adm.gift_btn": "Gift clips",
  "adm.credits_col": "Credits",
  "adm.gift_clips": "Number of clips",
  "adm.gift_note": "Message (optional)",
  "adm.gift_send": "Gift",
  "adm.gift_done": "{n} clips gifted to {e}",
  "gc.title": "Gift card",
  "adm.pr_used": "Used / ended",
  "gc.make": "Create a shareable gift card (unique link, 1 use)",
  "gc.to": "For (name or handle)",
  "gc.create": "Create card",
  "gc.download": "Download image",
  "gc.copy": "Copy message",
  "gc.copied": "Message copied!",
  "gc.share_text": "🎁 Here are {n} free clips on CLIP-EX! Claim them here: {u}",
  "gc.share_text_direct": "🎁 I gifted you {n} clips on CLIP-EX! They're already in your account.",
  "gc.hint_code": "Send the link or the image by text, Discord or email. The first person who uses it gets the clips.",
  "gc.hint_direct": "The clips are already in the customer's account: share this card to make their day.",
  "gc.headline": "You received {n} CLIP-EX clips!",
  "gc.for": "For",
  "gc.signup": "Create my account and get my clips",
  "gc.used": "This gift card has already been used.",
  "gc.direct": "These clips were already added to the account.",
  "gc.invalid": "Gift card not found.",
  "pro.title": "Auto Pro edit",
  "pro.desc": "One click and CLIP-EX edits like a pro: dead air cut, zooms on screams, hook, progress bar and \"Subscribe\" end screen.",
  "pro.on": "Pro edit on",
  "pro.cuts": "Cut silences and dead air",
  "pro.zooms": "Zoom on screams and sound peaks",
  "pro.whoosh": "Whoosh on each cut",
  "pro.hook": "AI hook at the start",
  "pro.progress": "Progress bar",
  "pro.endcard": "\"Subscribe\" end screen (2 s)",
  "pro.btn": "✨ Pro edit",
  "pro.preview_hint": "See the result with \"Real preview\" and in the exported clip.",
  "var.title": "3 variants + viral score",
  "var.desc": "One moment, three edits: hype, funny and cinematic. Each version gets a viral score /100 and 3 tips.",
  "var.btn": "Create 3 variants · 1 credit",
  "var.busy": "The AI is preparing your 3 edits…",
  "var.started": "3 variants are being created",
  "var.hype": "Hype",
  "var.funny": "Funny",
  "var.cinematic": "Cinematic",
  "var.best": "Top score",
  "var.rendering": "Editing…",
  "var.error": "Render failed",
  "var.tips": "Tips to blow up",
  "var.download": "Download",
  "var.see_all": "See in my clips",
  "var.need_range": "Pick a moment or a selection first.",
  "tpl.title": "My clip templates",
  "tpl.desc": "Save your style and apply it in 1 click. The ⭐ default template is applied automatically to every new AI, auto and live clip.",
  "tpl.name": "Template name (e.g. My TikTok style)",
  "tpl.save": "Save my style",
  "tpl.saved": "Template saved",
  "tpl.applied": "Template \"{n}\" applied",
  "tpl.default": "Default template",
  "tpl.set_default": "Set as default",
  "tpl.unset_default": "Remove default",
  "tpl.deleted": "Template deleted",
  "tpl.empty": "No templates yet: tune your clip, then save your style.",
  "tpl.auto_applied": "Your default template \"{n}\" is applied",
  "face.title": "Auto face reframe",
  "face.desc": "Detects your facecam: face on top, gameplay below following the action.",
  "face.found": "Facecam detected",
  "face.none": "No facecam detected",
  "face.scanning": "Looking for your face…",
  "face.detect": "Detect my face",
  "face.applied": "Facecam detected: split screen enabled",
  "face.only916": "Available in vertical 9:16 format",
  "hq.label": "Pro Quality",
  "hq.hint": "Sharpening, light denoise, vivid colors, normalized sound (-14 LUFS) and high-quality encoding.",
  "cmp.open": "Compare full screen",
  "cmp.title": "Compare your 3 variants",
  "cmp.desc": "They play at the same time. Tap a video to hear it, then keep the winner.",
  "cmp.play": "Play all",
  "cmp.pause": "Pause",
  "cmp.restart": "Restart",
  "cmp.listening": "Sound on",
  "cmp.tap_listen": "Tap to listen",
  "cmp.keep": "Keep this one",
  "cmp.kept": "Variant kept · {n} removed",
  "pub.btn": "Publish",
  "pub.title": "Publish my clip",
  "pub.desc": "Title, description and hashtags written by the AI, editable before sending.",
  "pub.soon": "soon",
  "pub.not_configured": "YouTube publishing is coming very soon: the CLIP-EX Google app is being configured.",
  "pub.connect": "Connect my YouTube channel",
  "pub.disconnect": "Disconnect",
  "pub.connected": "YouTube channel connected",
  "pub.r_denied": "YouTube connection cancelled",
  "pub.r_error": "YouTube connection failed, try again",
  "pub.r_nochannel": "No YouTube channel on this Google account",
  "pub.ai_filled": "Filled by the AI, edit anything you like",
  "pub.writing": "The AI is writing your title and hashtags…",
  "pub.f_title": "Title",
  "pub.f_desc": "Description",
  "pub.f_tags": "Hashtags",
  "pub.p_public": "Public",
  "pub.p_unlisted": "Unlisted",
  "pub.p_private": "Private",
  "pub.send": "Publish to YouTube Shorts",
  "pub.started": "Uploading to YouTube…",
  "pub.on_youtube": "Live on YouTube Shorts",
  "pub.uploading": "Uploading to YouTube…",
  "pub.failed": "Publishing failed",
  "pub.refresh": "Refresh",
  "pub.refreshed": "Views updated",
  "pub.refresh_failed": "Could not refresh views right now",
  "pub.build": "YouTube: under construction",
  "pub.build_hint": "Direct publishing to YouTube Shorts is coming soon.",
  "pl.result": "Result",
  "pl.source": "Source",
  "pl.final": "Final preview (6 s)",
  "adm.tab_stripe": "Stripe",
  "cr.ledger": "Credit history",
  "cr.no_ledger": "No credit movement yet.",
  "cr.refunded": "{n} clips refunded",
  "cr.k_purchase": "Credit purchase",
  "cr.k_holiday_pack": "Holiday pack unlocked",
  "cr.k_holiday_bonus": "Holiday purchase bonus",
  "cr.k_promo_bonus": "Promo code bonus",
  "cr.k_refund": "Refund (credits removed)",
  "cr.k_consume": "Clip generated",
  "cr.k_clip_refund": "Failed clip: credit returned",
  "cr.k_gift_code": "Gift code redeemed",
  "cr.k_gift_admin": "Gift from CLIP-EX",
  "cr.k_challenge": "Challenge won",
  "cr.k_referral": "Referral bonus",
  "gc.email": "Customer email (optional, sends the card)",
  "gc.emailed": "Gift card sent by email",
  "sc.btn": "Shortcuts",
  "sc.title": "Keyboard shortcuts",
  "sc.play": "Play / pause",
  "sc.start": "Selection start here",
  "sc.end": "Selection end here",
  "sc.save": "Save the selected moment",
  "sc.export": "Export the clip",
  "sc.seek1": "Back / forward 1 s",
  "sc.seek5": "Back / forward 5 s",
  "sc.mute": "Mute / unmute",
  "sc.final": "Final preview (6 s)",
  "sc.help": "Show this help",
  "sc.space": "Space",
  "sc.shift": "Shift + ← / →",
  "sc.start_set": "Start set",
  "sc.end_set": "End set",
  "ns.create": "Create",
  "ns.create_d": "Import a video, make clips",
  "ns.clips": "My clips",
  "ns.clips_d": "Clips, shares and stats",
  "ns.live": "Live",
  "ns.live_d": "OBS, Streamlabs, TikTok, live clips",
  "ns.account": "My account",
  "ns.account_d": "Credits, team and help",
  "ns.more": "More",
  "ns.community": "Community & extras",
  "sty.legend": "avg views · likes · avg viral score",
  "pub.vs_score": "Predicted viral score",
  "sty.title": "Which style works best",
  "sty.avg_views": "Average views per published clip",
  "sty.likes": "Likes",
  "sty.avg_score": "Average viral score",
  "sty.counts": "{c} clip(s) · {p} published",
  "sty.empty": "Publish your variants to YouTube Shorts to see which style gets the most views. Updated every 6 h.",
  "adm.ad_game_all": "All",
  "adm.ad_long_title": "Long ads 60 s",
  "adm.ad_long_sub": "Full presentations with AI voice-over: product, features, offers and promo codes.",
  "adm.ad_games_title": "Game ranking",
  "adm.ad_games_sub": "Visits and signups from the game's ads, purchases from its ads or its promo code.",
  "adm.ad_col_game": "Game",
  "adm.ad_col_purchases": "Purchases",
  "adm.ad_col_codes": "Codes used",
  "adm.ad_game_general": "General",
  "adm.ad_download": "Download",
  "adm.ad_copy": "Copy caption",
  "adm.ad_copied": "Caption copied with your tracked link!",
  "adm.ad_link_copied": "Tracked link copied!",
  "adm.ad_report_btn": "Get the weekly report now",
  "adm.ad_report_sent": "Report sent to your alert address.",
  "adm.ad_report_fail": "The report could not be sent.",
  "adm.ad_video": "Video",
  "adm.ad_image": "Image",
  "adm.ad_download_video": "6 s video",
  "adm.ad_stats": "Ad performance",
  "adm.ad_stats_sub": "Visits, sign-ups (up to 30 days after the click) and purchases, per ad and per network.",
  "adm.ad_stats_empty": "No visits yet. Post your ads with their tracked links to see results here.",
  "adm.ad_col_ad": "Ad", "adm.ad_col_src": "Network", "adm.ad_col_visits": "Visits", "adm.ad_col_signups": "Sign-ups",
  "adm.ad_col_rate": "Rate", "adm.ad_col_buyers": "Buyers", "adm.ad_col_rev": "Revenue", "adm.ad_total": "Total",
  "promo.ph": "Promo code",
  "promo.apply": "Apply",
  "promo.ok": "Code {code} applied!",
  "promo.applied": "Free bonus clips added after payment",
  "promo.plus": "+{n} free bonus clips",
  "adm.tab_promos": "Promo codes",
  "adm.tab_holidays": "Holidays",
  "hol.adm_intro": "Turn on a holiday skin across the site (subtle decor + color), sell sticker & sound packs for credits, and run promos. Every option turns on or off with one click.",
  "hol.adm_skin": "Holiday skin on the site",
  "hol.adm_pack": "Sticker & sound pack for sale",
  "hol.adm_price": "Price (credits)",
  "hol.adm_bonus": "Bonus credits on purchase",
  "hol.adm_promo": "Show a holiday promo code",
  "hol.adm_free": "Free pack with a purchase",
  "hol.adm_owners": "{n} own the pack",
  "hol.adm_saved": "Holidays updated",
  "hol.adm_promo_missing": "This code doesn't exist yet: create it in the Promo codes tab.",
  "hol.perk_bonus": "+{n}% credits on every pack",
  "hol.perk_pack": "free holiday pack with a purchase",
  "hol.perk_code": "code {c}",
  "hol.locked": "This sticker/sound is part of a holiday pack to unlock.",
  "hol.unlock": "Unlock",
  "hol.packs_title": "Holiday packs",
  "hol.packs_sub": "Exclusive stickers and sounds, unlocked once with your credits and yours forever.",
  "hol.pack_count": "{s} stickers · {n} sounds",
  "hol.buy": "Unlock · {n} credits",
  "hol.owned": "Unlocked",
  "hol.bought": "Pack unlocked! It's now in the editor.",
  "hol.sch_label": "Automatic dates (every year)",
  "hol.sch_auto": "computed",
  "hol.sch_bad": "Expected format: MM-DD (e.g. 12-01)",
  "hol.sch_live": "Live",
  "hol.sch_window": "Next period: {a} to {b}",
  "hol.sch_current": "Live: {a} to {b}",
  "hol.sch_reset": "Suggested dates",
  "hol.sch_intro": "With automatic dates, the holiday (skin + checked options) turns on and off by itself, Montreal time. Without dates, options work manually. A skin picked manually takes priority.",
  "hol.sch_now": "Skin visible right now: {n}.",
  "hol.sch_none": "No skin visible right now.",
  "hol.ov_label": "Holiday decor in my overlay",
  "hol.ov_now": "Current holiday: {n}",
  "hol.ov_none": "No holiday right now, nothing shows yet.",
  "hol.ov_preview": "Preview",
  "hol.ov_on": "Holiday decor turned on in your overlay",
  "hol.ov_off": "Holiday decor removed from your overlay",
  "hol.snd_on": "Turn on holiday sound",
  "hol.snd_off": "Mute holiday sound",
  "adm.pr_new": "New code",
  "adm.pr_code": "Code",
  "adm.pr_bonus_small": "Small bonus (10)",
  "adm.pr_bonus_medium": "Medium bonus (30)",
  "adm.pr_bonus_large": "Large bonus (100)",
  "adm.pr_max": "Max uses",
  "adm.pr_ends": "End date (optional)",
  "adm.pr_active": "Active",
  "adm.pr_inactive": "Inactive",
  "adm.pr_save": "Save",
  "adm.pr_uses": "{u}/{m} uses",
  "adm.ps_users": "People",
  "adm.ps_active": "Made clips",
  "adm.ps_clips": "Clips made",
  "adm.ps_buyers": "Bought",
  "adm.ps_revenue": "Sales after",
  "adm.ps_n_clips": "{n} clips",
  "adm.ps_empty": "Nobody has used this code yet.",
  "adm.pr_no_end": "No end date",
  "adm.pr_until": "Until {d}",
  "adm.pr_delete_confirm": "Delete this promo code?",
  "adm.pr_empty": "No promo codes.",
  "st.tab_music": "Music",
  "mu.vol": "Music",
  "mu.orig_vol": "Clip audio",
  "mu.note": "Original AI-made, royalty-free tracks: no risk of blocks on TikTok, Reels or Shorts. The music loops for the whole clip.",
  "mu.cat_all": "All", "mu.cat_meme": "Memes", "mu.cat_phonk": "Phonk", "mu.cat_drill": "Drill", "mu.cat_hype": "Hype", "mu.cat_epic": "Epic",
  "mu.cat_suspense": "Suspense", "mu.cat_comedy": "Comedy", "mu.cat_lofi": "Lo-fi", "mu.cat_emotional": "Emotional", "mu.cat_retro": "Retro",
  "cr.title": "Credits",
  "cr.sub": "1 credit = 1 exported clip, on top of your 3 free clips every week. Credits never expire.",
  "cr.free": "Free this week",
  "cr.bonus": "Bonus clips",
  "cr.paid": "Purchased credits",
  "cr.clips": "{n} clips",
  "cr.per_clip": "{p} / clip",
  "cr.buy": "Buy",
  "cr.soon": "Available soon",
  "cr.popular": "Popular",
  "cr.best": "Best value",
  "cr.secure": "Secure payment by Stripe · taxes calculated at checkout · in Canadian dollars",
  "cr.history": "Purchase history",
  "cr.no_history": "No purchases yet.",
  "cr.demo": "The demo account can't buy credits. Create your free account to continue.",
  "cr.out": "Your free clips for this week are used up.",
  "cr.get": "Get credits",
  "pay.checking": "Checking your payment…",
  "pay.success": "Payment successful!",
  "pay.success_sub": "Your credits have been added to your account.",
  "pay.pending": "Payment is still being confirmed. Check back in a few minutes.",
  "pay.failed": "The payment didn't go through.",
  "pay.cancel": "Payment cancelled",
  "pay.cancel_sub": "You were not charged.",
  "pay.back": "Back to credits",
  "pay.to_clips": "Create a clip",
  "ex.bars": "Black bars",
  "ex.split": "Split screen",
  "fr.zone_cam": "Facecam",
  "fr.zone_game": "Gameplay",
  "fr.split_ratio": "Facecam size",
  "fr.hint_split": "Drag and zoom each zone separately",
  "fr.cam_pick": "Draw your facecam rectangle",
  "fr.cam_hint": "Draw a rectangle over your camera, or drag it to move it.",
  "fr.memory": "Your framing is remembered for this format and reused on your next clips.",
  "fr.title": "Video framing",
  "fr.reset": "Reset",
  "fr.hint": "Drag to move · scroll or pinch to zoom",
  "fr.grid": "Rule of thirds",
  "fr.safe": "Safe zones",
  "fr.safe_ui": "App interface",
  "fr.safe_caption": "Text and caption",
  "fr.preset_center": "Centered",
  "fr.preset_facecam": "Facecam on top",
  "fr.preset_gameplay": "Full-screen gameplay",
  "adm.demo_title": "Demo account",
  "adm.demo_desc": "Wipes the demo account videos and clips and restores a clean example: 1 AI-analysed video and 3 ready clips (9:16, 16:9, 1:1).",
  "adm.demo_btn": "Reset demo",
  "adm.demo_confirm": "Erase all demo account content and restore the example?",
  "adm.demo_done": "Reset started: the 3 clips will be ready in about a minute.",
  "nav.following": "Following",
  "nav.challenges": "Challenges",
  "ch.nav": "Challenges",
  "ch.label": "Weekly challenge",
  "ch.title1": "The community ",
  "ch.title2": "challenge",
  "ch.sub": "Enter your best shared clip. The community votes with reactions: the clip with the most reactions when the challenge ends wins bonus clips.",
  "ch.none": "No challenge running right now. Come back soon!",
  "ch.active": "Live",
  "ch.upcoming": "Upcoming",
  "ch.ended": "Ended",
  "ch.reward": "{n} bonus clips for the winner",
  "ch.entries": "{n} clips entered",
  "ch.entries_one": "{n} clip entered",
  "ch.ends_in": "Ends in",
  "ch.starts": "Starts {date}",
  "ch.ended_on": "Ended {date}",
  "ch.days": "d", "ch.hours": "h", "ch.minutes": "min",
  "ch.enter": "Enter my clip",
  "ch.change": "Change my clip",
  "ch.withdraw": "Withdraw my clip",
  "ch.withdrawn": "Clip withdrawn",
  "ch.entered": "Clip entered!",
  "ch.login": "Log in to take part",
  "ch.my_entry": "Your clip is entered",
  "ch.ranking": "Live ranking",
  "ch.vote_hint": "Vote for your favourite clips with fire, skull and GG reactions. One reaction of each type per device.",
  "ch.no_entries": "No clips entered yet. Be the first!",
  "ch.score": "{n} reactions",
  "ch.score_one": "{n} reaction",
  "ch.winner": "Winner",
  "ch.no_winner": "No winner (no reactions)",
  "ch.past": "Past challenges",
  "ch.pick_title": "Pick the clip to enter",
  "ch.pick_desc": "Only your publicly shared clips can take part. One clip per workspace per challenge.",
  "ch.pick_empty": "You have no shared clip yet. Turn on “Share” for an exported clip, then come back.",
  "ch.pick_confirm": "Enter this clip",
  "ch.game": "Game",
  "ch.rules": "The winner gets the bonus clips automatically when the challenge ends. Bonus clips never expire.",

  "adm.tab_challenges": "Challenges",
  "adm.ch_new": "New challenge",
  "adm.ch_edit": "Edit challenge",
  "adm.ch_title": "Title (e.g. Best clutch)",
  "adm.ch_desc": "Description and rules",
  "adm.ch_game": "Game (optional)",
  "adm.ch_start": "Start",
  "adm.ch_end": "End",
  "adm.ch_save": "Save",
  "adm.ch_cancel": "Cancel",
  "adm.ch_created": "Challenge saved",
  "adm.ch_close": "Close now",
  "adm.ch_close_confirm": "Close this challenge now and award the bonus clips to the leading clip?",
  "adm.ch_closed": "Challenge closed",
  "adm.ch_delete": "Delete",
  "adm.ch_delete_confirm": "Delete this challenge and its entries?",
  "adm.ch_deleted": "Challenge deleted",
  "adm.ch_empty": "No challenges yet. Create the first one!",
  "adm.ch_leader": "Leading",
  "adm.ch_intro": "Create weekly challenges. Creators enter a shared clip, the community votes with reactions and the winner automatically gets 3 bonus clips at the end.",

  "adm.tab_email": "Emails",
  "adm.tab_cleanup": "Cleanup",
  "adm.tab_real": "Real numbers",
  "adm.em_title": "Sending domain",
  "adm.em_intro": "Emails switch automatically to {sender} as soon as the domain is verified in Resend. Until then, the current sender is used. Status is rechecked every 15 minutes.",
  "adm.em_active": "Active: emails are sent from {sender}",
  "adm.em_pending": "Waiting for DNS verification",
  "adm.em_failed": "Verification failed: check the records",
  "adm.em_missing": "Domain not found in the Resend account",
  "adm.em_unreachable": "Resend unreachable right now",
  "adm.em_records": "DNS records to add at your registrar",
  "adm.em_type": "Type", "adm.em_name": "Name", "adm.em_value": "Value", "adm.em_prio": "Priority", "adm.em_status": "Status",
  "adm.em_verify": "Verify now",
  "adm.em_verified": "Verification restarted",
  "adm.em_copied": "Copied",
  "adm.em_tip": "Tip: at most registrars the “Name” field is written without “clip-ex.ca” at the end. DNS propagation can take a few minutes up to 48 h.",

  "fw.follow": "Follow",
  "fw.following": "Following",
  "fw.unfollow": "Unfollow",
  "fw.followed": "You now follow {name}",
  "fw.unfollowed": "You no longer follow {name}",
  "fw.self": "This is your profile",
  "fw.label": "Your feed",
  "fw.title1": "My ",
  "fw.title2": "following",
  "fw.sub": "The latest clips shared by the creators you follow.",
  "fw.creators": "Creators you follow",
  "fw.empty": "You don't follow any creator yet. Discover some in the showcase and hit “Follow” on their profile.",
  "fw.no_clips": "The creators you follow haven't shared a clip yet.",
  "fw.discover": "Explore the showcase",
};
